import { Box } from "@mui/material";
import { InfoOutlined } from "@mui/icons-material";
import { CSSProperties } from "react";
import { setDimensionadoDrawerStatus } from "src/store/vendas/projetos/actions";
import theme from "src/theme/light";

interface InputPrefixProps {
  styles?: CSSProperties
}

export function InputPrefix({ styles = {} }: InputPrefixProps){
  return (
    <Box
      onClick={() => setDimensionadoDrawerStatus(true)}
      component={"button"}
      display="flex"
      alignItems={"center"}
      justifyContent={"center"}
      border={"none"}
      bgcolor={"transparent"}
      style={{ cursor: 'pointer', outline: 'none', ...styles }}
      >
        <InfoOutlined
          htmlColor={theme.palette.grey[600]}
          fontSize={"small"}
        />
    </Box>
  )
}